@if (!customerModel.data.newsletter) {
<form-field class="m-t-3 block">
    <p class="flex flex-middle">
        <i class="icon-email"></i>
        <span class="s1 m-l-3">{{'Sign up to our newsletter' | translate}}</span>
    </p>
    <div class="left p2 col-11 m-t-5 m-t-4-m m-t-4-s">
        <p class="p2 inline-block-s inline-block-m">
            {{ 'By signing up to receive our newsletter you accept our' }}
        </p>
        <a target="_blank"
           routerLink="/customer-service/privacy">{{'Privacy policy' | translate}}</a> and
        <a target="_blank"
           routerLink="/customer-service/terms">{{'Terms & Conditions'|translate}}</a>.
    </div>
    <div class="inline-flex m-t-5 m-t-6-m m-t-6-s">
        <radio><input type="radio"
                   name="newsletter"
                   [(ngModel)]="model"
                   [value]="1">
            <p class="inline-flex flex-middle">{{ 'Yes, please' | translate }}</p>
        </radio>
        <radio class="m-l-10"><input type="radio"
                   name="newsletter"
                   [(ngModel)]="model"
                   [value]="0">
            <p class="inline-flex flex-middle">{{ 'No, thanks' | translate }}</p>
        </radio>
    </div>
</form-field>
}